import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Nav, Navbar, Row} from "reactstrap";

class PolyFlowNavigator extends Component {

    content = () => {
        const keyedChildren = React.Children.map(this.props.children, (child, i) => {
            return React.cloneElement(child, {
                itemKey: i,
                id: this.props.id,
                active: this.props.flowKey.value === i
            });
        });

        return (
            <div>
                <Navbar className="app-nav">
                    <Nav className="m-auto" navbar>
                        <Row>
                            {keyedChildren}
                        </Row>
                    </Nav>
                </Navbar>
            </div>
        );
    };

    render() {
        return !!this.props.flowKey ? this.content() : null;
    }
}

PolyFlowNavigator.propTypes = {
    id: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
    flowKey: state.display.flowKeys.find(key => key.id === props.id)
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PolyFlowNavigator);




// WEBPACK FOOTER //
// ./src/components/flow/PolyFlow/PolyFlowNavigator.js